import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import { createNewPatient } from "../../services/api";
import ProgressBar from "../../components/ProgressBarWithBackArrow/ProgressBarWithBackArrow";
import Alert from "../../assets/images/alert.png";
import "../SignupPages/SignupCommon.css";


const NadPlusPage4: React.FC = () => {
  const [firstName, setFirstName] = useState<string>("");
  const [uuidValue, setUuidValue] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [state, setState] = useState<string>("");
  const [isSubscribed, setIsSubscribed] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState<string>("");
  const [phoneError, setPhoneError] = useState<string>("");
  const navigate = useNavigate();
  const [err, setErr] = useState<string>("");
  const location = window.location.pathname;
  const isSermorelinPage = location.includes("sermorelin");
  const [stateError, setStateError] = useState<string>("");
  useEffect(() => {
        const step3Completed = localStorage.getItem("completed-step-3");
        if(isSermorelinPage){
          if (step3Completed) {
            navigate("/sermorelin/getting-started/step-4", { replace: true });
          } else {
            navigate("/sermorelin/getting-started/step-3", { replace: true });
          }
        }else{
          if (step3Completed) {
            navigate("/nadplus/getting-started/step-4", { replace: true });
          } else {
            navigate("/nadplus/getting-started/step-3", { replace: true });
          }
        }
      }, []);
  useEffect(() => {
    const getItem = localStorage.getItem("uuid");
    if (getItem) {
      setUuidValue(JSON.parse(getItem).value);
    }
  });
  useEffect(() => {
    setUuidValue(uuidValue);
  }, [uuidValue]);

  const handleNext = async () => {
    if (!isValidEmail(email)) {
      setEmailError(
        "Invalid email address. Please enter a valid email address."
      );
      return;
    } else {
      setEmailError("");
    }

    const cleanedPhone = phone.replace(/\D/g, "");
    if (!isValidPhone(cleanedPhone)) {
      setPhoneError(
        "Invalid phone number. Please enter a 10-digit phone number."
      );
      return;
    } else {
      setPhoneError("");
    }

    if (firstName && lastName && email && phone && state) {
      localStorage.setItem(
        "firstName",
        JSON.stringify({ key: "firstName", value: firstName })
      );
      localStorage.setItem(
        "lastName",
        JSON.stringify({ key: "lastName", value: lastName })
      );
      localStorage.setItem(
        "email",
        JSON.stringify({ key: "email", value: email })
      );
      localStorage.setItem(
        "phone",
        JSON.stringify({ key: "phone", value: phone })
      );
      localStorage.setItem(
        "state",
        JSON.stringify({ key: "state", value: state })
      );
      localStorage.setItem(
        "isSubscribed",
        JSON.stringify({ key: "isSubscribed", value: isSubscribed })
      );
      localStorage.setItem(
        "fullName",
        JSON.stringify({ key: "firstName", value: firstName + " " + lastName })
      );

      try {
        setLoading(true);
        const productCategory = isSermorelinPage? "Sermorelin" : "NAD+"; 
  
        const appointmentResponse = await createNewPatient(
          firstName,
          lastName,
          email,
          phone,
          isSubscribed,
          productCategory,
          uuidValue
        );
  
        const data = await appointmentResponse.json();
  
        if (!appointmentResponse.ok) {
          setErr(data?.error || "Failed to create patient.");
          throw new Error(data?.error || "Failed to create patient.");
        }
  
     
        if (data && data.user && data.user.length > 0) {
          const patientData = data.user[0]; 
          const disableAddress = data.disable_address || false; 
  
          localStorage.setItem(
            "disable_address",
            JSON.stringify({ key: "disable_address", value: disableAddress })
          );
  
          console.log(patientData, "patientData");
  
         
          if (patientData.addressLineOne)
            localStorage.setItem(
              "addressLine1",
              JSON.stringify({
                key: "addressLine1",
                value: patientData.addressLineOne,
              })
            );
          if (patientData.addressLineTwo)
            localStorage.setItem(
              "addressLine2",
              JSON.stringify({
                key: "addressLine2",
                value: patientData.addressLineTwo,
              })
            );
          if (patientData.city)
            localStorage.setItem(
              "city",
              JSON.stringify({ key: "city", value: patientData.city })
            );
          if (patientData.state)
            localStorage.setItem(
              "state",
              JSON.stringify({ key: "state", value: patientData.state })
            );
          if (patientData.zipCode)
            localStorage.setItem(
              "zip",
              JSON.stringify({ key: "zip", value: patientData.zipCode })
            );
  
      
          if (
            patientData.state 
          ) {
            localStorage.setItem(
              "state",
              JSON.stringify({
                key: "state",
                value:
                  patientData.state,
              })
            );
          }
        } else {
  
          localStorage.setItem(
            "disable_address",
            JSON.stringify({ key: "disable_address", value: false })
          );
        }

        if(isSermorelinPage){
          navigate("/sermorelin/getting-started/step-5");
        }else{
          navigate("/nadplus/getting-started/step-5");
        }
        
        localStorage.setItem("completed-step-4", "true");
      } catch (error: unknown) {
        if (error instanceof Error) {
          setErr(error.message);
        } else {
          setErr("An unexpected error occurred.");
        }
        console.error("Error adding patient:", error);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    const savedFirstName = localStorage.getItem("firstName");
    const savedLastName = localStorage.getItem("lastName");
    const savedEmail = localStorage.getItem("email");
    const savedPhone = localStorage.getItem("phone");
    const savedIsSubscribed = localStorage.getItem("isSubscribed");
    const savedState = localStorage.getItem("state");

    if (savedFirstName) {
      const parsedFirstName = JSON.parse(savedFirstName);
      setFirstName(parsedFirstName.value);
    }
    if (savedLastName) {
      const parsedLastName = JSON.parse(savedLastName);
      setLastName(parsedLastName.value);
    }
    if (savedEmail) {
      const parsedEmail = JSON.parse(savedEmail);
      setEmail(parsedEmail.value);
    }
    if (savedPhone) {
      const parsedPhone = JSON.parse(savedPhone);
      setPhone(parsedPhone.value);
    }
    if (savedIsSubscribed) {
      const parsedIsSubscribed = JSON.parse(savedIsSubscribed);
      setIsSubscribed(parsedIsSubscribed.value);
    }
    if (savedState) {
      const parsedState = JSON.parse(savedState);
      if (parsedState.value === "AR") {
        setStateError("Sorry, currently we do not offer the medication in Arkansas.");
      } else {
        setState(parsedState.value);
      }
    }
  }, []);
  const isValidEmail = (email: string): boolean => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(email);
  };

  const isValidPhone = (phone: string): boolean => {
    const phonePattern = /^\d{10}$/;
    return phonePattern.test(phone);
  };

  const styles = {
    container: {
      maxWidth: "500px",
      margin: "0 auto",
    },
    content: {
      marginTop: "20px",
    },
    label: {
      marginBottom: "10px",
      fontWeight: "bold",
    },
    inputContainer: {
      marginBottom: "20px",
    },
    input: {
      width: "560px",
      height: "52px",
      padding: "10px",
      fontSize: "16px",
      border: "1px solid #D9D9D9",
      borderRadius: "154px",
      background: "#FFF",
    },
    button: {
      backgroundColor: "#007bff",
      color: "white",
      padding: "10px 20px",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "16px",
      marginTop: "20px",
    },
    disabledButton: {
      backgroundColor: "#ccc",
      cursor: "not-allowed",
    },

    checkboxContainer: {
      display: "flex",
      alignItems: "center",
    },
    loader: {
      border: "4px solid #f3f3f3",
      borderTop: "4px solid #3498db",
      borderRadius: "50%",
      width: "20px",
      height: "10px",
      animation: "spin 1s linear infinite",
    },
  };

  const formatPhoneNumber = (value: string): string => {
    const cleaned = ("" + value).replace(/\D/g, "");
    if (cleaned.length > 10) {
      setPhoneError("Phone number cannot exceed 10 digits");
      return value;
    } else {
      setPhoneError("");
    }

    if (cleaned.length <= 3) {
      return `(${cleaned}`;
    } else if (cleaned.length <= 6) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    } else {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
        6,
        10
      )}`;
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const cleaned = value.replace(/\D/g, "");
    if (cleaned.length <= 10) {
      setPhone(formatPhoneNumber(value));
    }
  };

  const stateOptions = {
    AK: "Alaska",
    AL: "Alabama",
    AR: "Arkansas",
    AZ: "Arizona",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DC: "District of Columbia",
    DE: "Delaware",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    IA: "Iowa",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    MA: "Massachusetts",
    MD: "Maryland",
    ME: "Maine",
    MI: "Michigan",
    MN: "Minnesota",
    MO: "Missouri",
    MS: "Mississippi",
    MT: "Montana",
    NC: "North Carolina",
    ND: "North Dakota",
    NE: "Nebraska",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NV: "Nevada",
    NY: "New York",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VA: "Virginia",
    VT: "Vermont",
    WA: "Washington",
    WI: "Wisconsin",
    WV: "West Virginia",
    WY: "Wyoming",
  };

    const handleStateChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
      const selectedState = e.target.value as keyof typeof stateOptions; // Type assertion
  
      if(selectedState === "AR"){
        setStateError("Sorry, currently we do not offer the medication in Arkansas.");
        localStorage.removeItem("state");
        localStorage.removeItem("fullState");
      }else{
        setStateError("");
      }
        setState(selectedState);
        localStorage.setItem(
          "state",
          JSON.stringify({ key: "state", value: selectedState })
        );
        localStorage.setItem(
          "fullState",
          JSON.stringify({ key: "fullState", value: stateOptions[selectedState] })
        );
    };

  const inputError = (errorMessage: string) => {
    if(!errorMessage) return null;
    return (
      <div className="checkout-state-error" style={{marginTop: '20px', borderRadius: "58px", marginBottom: "10px"}}>
        <img src={Alert} alt="state-error" width={"16px"} height={"15px"}/>
        <p className="checkout-state-error-text">{errorMessage}</p>
      </div>
    )
  }

  const handleBack = () => {
    if(isSermorelinPage){
      navigate("/sermorelin/getting-started/step-3")
    }else{
    navigate("/nadplus/getting-started/step-3")
    }
  }

  return (
    <PageWrapper>
      <div className="signup-page-container">
        <ProgressBar progress={40} onBack={handleBack}/>
        <div className="signup-content">
          <p className="signup-intro-info">
            Amazing! You’ve been pre-approved as an ideal candidate for{" "}
            <span className="signup-intro-special-words">
              Claya&apos;s { isSermorelinPage ? "Sermorelin"  : "NAD+"} wellness
            </span>{" "}
            journey.
          </p>
          <p className="signup-intro-para-second" style={{ marginBottom: 30 }}>
            To receive your tailored medication plan and begin your wellness
            journey with Claya, enter the following contact information.
          </p>

          <div style={styles.inputContainer}>
            <input
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder="First name"
              className="input-fields"
            />
          </div>

          <div style={styles.inputContainer}>
            <input
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              placeholder="Last name"
              className="input-fields"
            />
          </div>

          <div style={styles.inputContainer}>
            <input
              type="email"
              value={email}
              onChange={(e) => {setEmail(e.target.value)
                setEmailError("");
                setErr("")
              }}
              placeholder="Email"
              className="input-fields"
            />
            {emailError && inputError(emailError)}
          </div>

          <div style={styles.inputContainer}>
            <input
              type="tel"
              value={phone}
              onChange={handleChange}
              placeholder="Phone number: (XXX) XXX-XXXX"
              className="input-fields"
            />
            {phoneError && inputError(phoneError)}
          </div>
          <div className="select-container">
            <select
              id="state"
              name="state"
              value={state}
              onChange={handleStateChange} // Use the new handler
              className="minimal bg-red mb-0 items-center justify-center border border-gray-200 align-middle text-sm border-red-200 rounded-md outline-none focus:outline-none"
            >
              <option value="">Select a state</option>
              {Object.entries(stateOptions).map(([abbreviation, fullName]) => (
                <option key={abbreviation} value={abbreviation}>
                  {fullName}
                </option>
              ))}
            </select>
          </div>
          {stateError && inputError(stateError)}

          <div style={styles.checkboxContainer}>
            <input
              type="checkbox"
              checked={isSubscribed}
              onChange={() => setIsSubscribed(!isSubscribed)}
              style={{cursor: "pointer"}}
            />
            <label className="checkboxLabel">
              By subscribing, you agree to receive Account Notification text
              messages at the phone number provided. Reply STOP to cancel.
              Message and data rates may apply.
            </label>
          </div>
          {err && inputError(err)}
          <button
            onClick={handleNext}
            disabled={!(firstName && lastName && email && phone && state && isSubscribed) || !!stateError || loading} 
            className="next-btn"
            style={{
              backgroundColor:
                loading || !!stateError || !(firstName && lastName && email && phone && state && isSubscribed)
                  ? "#d3d3d3" 
                  : "#0c3972", 
            }}
          >
            {loading ? "Loading..." : "Continue →"}
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default NadPlusPage4;